import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "the-a01-point-notification-carousel__carousel c-swiper c-swiper--outer_pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_A01PointNotificationPanelThanks = _resolveComponent("A01PointNotificationPanelThanks")!
  const _component_A01PointNotificationPanelInvested = _resolveComponent("A01PointNotificationPanelInvested")!
  const _component_A01PointNotificationPanelThanksOnlyPoint = _resolveComponent("A01PointNotificationPanelThanksOnlyPoint")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", {
    class: "the-a01-point-notification-carousel",
    style: _normalizeStyle({
      '--site-color': _ctx.colorCode,
      '--swiper-pagination-color': _ctx.colorCode,
      '--swiper-pagination-bullet-inactive-color': '#dadada',
      '--swiper-pagination-bullet-inactive-opacity': 1
    })
  }, [
    (_ctx.useCarousel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Swiper, {
            loop: true,
            autoplay: { delay: 5000 },
            pagination: { clickable: true }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pointNoticeCards, (pointNoticeCard, key) => {
                return (_openBlock(), _createBlock(_component_SwiperSlide, { key: key }, {
                  default: _withCtx(() => [
                    (_ctx.thanksPointTypes.includes(pointNoticeCard.transactionType))
                      ? (_openBlock(), _createBlock(_component_A01PointNotificationPanelThanks, {
                          key: 0,
                          giver: _ctx.giver(pointNoticeCard),
                          point: pointNoticeCard.points,
                          url: _ctx.urls(pointNoticeCard)
                        }, null, 8, ["giver", "point", "url"]))
                      : _createCommentVNode("", true),
                    (_ctx.grantPointTypes.includes(pointNoticeCard.transactionType))
                      ? (_openBlock(), _createBlock(_component_A01PointNotificationPanelInvested, {
                          key: 1,
                          title: pointNoticeCard.grantCriteriaName,
                          "invested-reason": pointNoticeCard.grantCriteriaName,
                          point: pointNoticeCard.points,
                          url: _ctx.urls(pointNoticeCard)
                        }, null, 8, ["title", "invested-reason", "point", "url"]))
                      : _createCommentVNode("", true),
                    (_ctx.thanksOnlyPointTypes.includes(pointNoticeCard.transactionType))
                      ? (_openBlock(), _createBlock(_component_A01PointNotificationPanelThanksOnlyPoint, {
                          key: 2,
                          point: pointNoticeCard.points,
                          url: _ctx.urls(pointNoticeCard)
                        }, null, 8, ["point", "url"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.pointNoticeCards, (pointNoticeCard, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_ctx.thanksPointTypes.includes(pointNoticeCard.transactionType))
              ? (_openBlock(), _createBlock(_component_A01PointNotificationPanelThanks, {
                  key: key,
                  giver: _ctx.giver(pointNoticeCard),
                  point: pointNoticeCard.points,
                  url: _ctx.urls(pointNoticeCard)
                }, null, 8, ["giver", "point", "url"]))
              : _createCommentVNode("", true),
            (_ctx.grantPointTypes.includes(pointNoticeCard.transactionType))
              ? (_openBlock(), _createBlock(_component_A01PointNotificationPanelInvested, {
                  key: key,
                  title: pointNoticeCard.grantCriteriaName,
                  "invested-reason": pointNoticeCard.grantCriteriaName,
                  point: pointNoticeCard.points,
                  url: _ctx.urls(pointNoticeCard)
                }, null, 8, ["title", "invested-reason", "point", "url"]))
              : _createCommentVNode("", true),
            (_ctx.thanksOnlyPointTypes.includes(pointNoticeCard.transactionType))
              ? (_openBlock(), _createBlock(_component_A01PointNotificationPanelThanksOnlyPoint, {
                  key: key,
                  point: pointNoticeCard.points,
                  url: _ctx.urls(pointNoticeCard)
                }, null, 8, ["point", "url"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
  ], 4))
}